import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import SpriteUtils from "@/utils/sprite-utils";
import TextButton from "@/scenes.ui/text-button";
import CU from "@/utils/c-u";
import {Settings} from "@/constants/settings";
import PlayerStore from "@/store/player";

export class LangSelectPanel extends VerticalStandardPanel {

    private readonly DEPTH: number = 3000;
    private onReloadCallback!: () => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, onReloadCallback: () => unknown,
                title: string, text: string, updateProfile: boolean = true) {
        super(scene, canvas, title.toUpperCase());

        this.setDepth(this.DEPTH);

        this.title.setFontSize(35);
        this.title.setColor("#831B1F");

        this.onReloadCallback = onReloadCallback;

        let mainText = TextUtils.addTextByFamily(scene, text, 0, -200,
            '#716E69', 16, 'normal', 450, Fonts.BENGALY_NORMAL);

        let i = 0;
        let langButtonHeight = 40;
        for (const availLang of Settings.AVAILABLE_LANGUAGES) {
            let buttImage = Keys.UI_LANG_BUTT_UNAVAL;
            let langButton = new TextButton(
                scene, 0, -160, buttImage, availLang.langDescr, '#94928C', 'normal'
            );

            langButton.setPosition(langButton.x, langButton.y + i);
            langButton.height = langButtonHeight;
            langButton.width = CU.CANVAS_WIDTH;
            langButton.setOrigin(0.5, 0.5);

            langButton.setCallback(() => {
                if (this.isOnTop() && availLang.available) {

                    PlayerStore.setLang(() => {
                        if (this.onReloadCallback() != null) { this.onReloadCallback(); }
                    }, availLang.langId, updateProfile);
                    this.close();
                }
            });
            this.add(langButton)
            i += 65 * CU.S ;
        }

        this.add([mainText]);

        SpriteUtils.scale(this, 0.9);
    }
}
